import apiCall from '@/utils/api';
import router from '@/router';
import qs from 'qs';

const state = {
	id: {},
	title: '',
	code: '',
	rounds: 0,
	all_users: [],
	all_rooms: [],
};

const mutations = {
	set_room_id(state, payload) {
		state.id = payload;
	},
	set_room_state(state, payload) {
		state.title = payload.title;
		state.code = payload.code;
		state.rounds = payload.rounds;
		state.all_users = payload.all_users;
	},
	set_rooms(state, payload) {
		state.all_rooms = payload;
	},
};

const getters = {
	user_name: (state, getters) => room_user_id =>
		state.all_users.filter(({ id }) => id === room_user_id)[0].name,
};

const actions = {
	create_room: ({ commit }, room_params) => {
		const params = {
			room: { title: room_params.title },
			username: room_params.username,
		};
		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: qs.stringify(params),
			url: 'api/v1/rooms',
		};

		apiCall(options).then(response => {
			router.push({
				name: 'Room',
				params: { room_id: response.data.room_id },
			});
		});
	},
	join_room: ({ commit }, room_params) => {
		const params = {
			room_code: room_params.room_code,
			username: room_params.username,
		};

		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: qs.stringify(params),
			url: 'api/v1/rooms/join',
		};

		apiCall(options).then(response => {
			router.push({
				name: 'Room',
				params: { room_id: response.data.room_id },
			});
		});
	},
	get_user_rooms: ({ commit, state }) => {
		const options = {
			method: 'GET',
			url: `api/v1/rooms`,
		};

		apiCall(options).then(({ data }) => {
			commit('set_rooms', data.rooms);
		});
	},
	get_room: ({ commit, state }) => {
		const options = {
			method: 'GET',
			url: `api/v1/rooms/${state.id}`,
		};

		apiCall(options).then(({ data }) => {
			commit('set_room_state', {
				title: data.room.title,
				code: data.room.code,
				rounds: data.draft_data.rounds,
				all_users: data.users.all,
			});
			commit('set_current_picker', data.draft_data.current_picker);
			commit('set_current_user_id', data.users.current_id);
			commit(
				'set_current_commissioner_status',
				data.users.is_commissioner
			);
			commit('set_current_user_name', data.users.current);

			let playersObj = {};
			data.players.forEach(
				player =>
					(playersObj[player.id] = {
						name: player.name,
						id: player.id,
						position: player.position,
						team: player.team,
						is_queued: false,
					})
			);
			commit('set_players', playersObj);
			commit('set_picks', data.picks);
		});
	},
};

export default {
	state,
	mutations,
	getters,
	actions,
};
